import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
    POST_DELIVERYSTATUS_INIT_ACTION,
    POST_DELIVERYSTATUS_SUCCESS_ACTION,
    POST_DELIVERYSTATUS_FAIL_ACTION,
    GET_DELIVERYSTATUS_INIT_ACTION,
    GET_DELIVERYSTATUS_SUCCESS_ACTION,
    GET_DELIVERYSTATUS_FAIL_ACTION,
    DELETE_DELIVERYSTATUS_INIT_ACTION,
    DELETE_DELIVERYSTATUS_SUCCESS_ACTION,
    DELETE_DELIVERYSTATUS_FAIL_ACTION,
    EDIT_DELIVERYSTATUS_INIT_ACTION,
    EDIT_DELIVERYSTATUS_SUCCESS_ACTION,
    EDIT_DELIVERYSTATUS_FAIL_ACTION
} from "./action";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function* postDeliverystatus(val) {
    const token = localStorage.getItem("token");
    console.log(val);
    try {
      const data={name:val.value.statusname,disc:val.value.statusdesc,sortOrder:val.value.sortorder,isActive:val.value.active};
      const res = yield fetch(`${appConfig.ip}/dlryStatus`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      if (!res.ok) {
        throw res;
      } else {
        const resJSON = yield res.json();
        yield put({
          type: POST_DELIVERYSTATUS_SUCCESS_ACTION,
          payload: resJSON,
        });
        yield put({type: GET_DELIVERYSTATUS_INIT_ACTION});

        yield toast.success(`Delivery status posted succesfully`, {
          autoClose: 5000,
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({ type: POST_DELIVERYSTATUS_FAIL_ACTION, error: err });
      } else {
      }
      yield toast.error("Error!!Delivery status not posted", {
        autoClose: 3000,
      });
    }
  }

 function* getDeliverystatus(val) {
    const token = localStorage.getItem("token");
    console.log(token);

    let pageno = (!(val.value)) ? 1 : (val.value.page === undefined ? 1 : val.value.page);
  
    try {
      const res = yield fetch(
        `${appConfig.ip}/dlryStatus?limit=10&page=${pageno}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!res.ok) {
        throw res;
      } else {
        const resJSON = yield res.json();
  
        yield put({
          type: GET_DELIVERYSTATUS_SUCCESS_ACTION,
          payload: resJSON,
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({ type: GET_DELIVERYSTATUS_FAIL_ACTION, error: err });
      } else {
      }
    }
   }

   function* deleteStatus(val) {
    const token = localStorage.getItem("token");
    const id = val.value;
    console.log(val);
  
    try {
      const res = yield fetch(
        `${appConfig.ip}/dlryStatus/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(res.url);
      if (!res) {
        throw res;
      } else {
        yield put({
          type: DELETE_DELIVERYSTATUS_SUCCESS_ACTION,
        });
        yield put({type: GET_DELIVERYSTATUS_INIT_ACTION});

        yield toast.success(`Delivery status deleted succesfully`, {
          autoClose: 3000,
        });
      }
    } catch (err) {
      console.log(err);
      if (err.ok === false) {
        yield put({ type: DELETE_DELIVERYSTATUS_FAIL_ACTION, error: err });
      } else {
      }
      yield toast.error(`Delivery status not deleted`, {
        autoClose: 3000,
      });
    }
   }

  function* editDeliverystatus(val) {
    const token = localStorage.getItem("token");
    console.log(token);
    const id = val.value.id;
    console.log(val);

    try {
      const data={name:val.value.statusname,disc:val.value.statusdesc,sortOrder:val.value.sortorder,isActive:val.value.active};
      const res = yield fetch(`${appConfig.ip}/dlryStatus/${id}`,
        {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      if (!res) {
        throw res;
      } else {
        const resJSON = yield res.json();
        yield put({
          type: EDIT_DELIVERYSTATUS_SUCCESS_ACTION,
          payload: resJSON,
        });
        yield put({type: GET_DELIVERYSTATUS_INIT_ACTION});

        yield toast.success(`Delivery status edited succesfully`, {
          autoClose: 3000,
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({ type: EDIT_DELIVERYSTATUS_FAIL_ACTION, error: err });
      } else {
      }
      yield toast.error("Error!!Delivery status not edited", {
        autoClose: 3000,
      });
    }
  }

export function* DeliveryStausActionWatcher() {
  yield takeEvery(POST_DELIVERYSTATUS_INIT_ACTION, postDeliverystatus);
  yield takeEvery(GET_DELIVERYSTATUS_INIT_ACTION, getDeliverystatus);
  yield takeEvery(DELETE_DELIVERYSTATUS_INIT_ACTION, deleteStatus);
  yield takeEvery(EDIT_DELIVERYSTATUS_INIT_ACTION, editDeliverystatus);
}
